import CloseIcon from "../../../../assets/icons/close.svg";
import styles from "./UpdateFavouritesHeader.module.scss";
import FilterHeaderButton from "../../../Filter/components/FilterHeaderButton";
import { MARKETS_VIEW, UPDATE_FAVOURITES_VIEW } from "../../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { generateFavouriteName } from "../../../../lib/string";
import { sendAnalyticsEvent, sendMessage } from "../../../../lib/postMessage";
import { generateFavouriteId } from "../../../../lib/favourites";
import { ADDTO, CREATE, FAVOURITES } from "../../../../constants/analytics";

function UpdateFavouritesHeader({ selectedFavourite, children }) {
  const { activeView } = useSelector((state) => state.view);
  const { prefetchedFilters, storedFavourites } = useSelector(
    (state) => state.filter
  );

  const dispatch = useDispatch();

  const closeFilter = () => {
    window.scrollTo(0, 0);
    dispatch({
      type: "SET_ACTIVE_VIEW",
      payload: "",
    });
  };

  const createNewFavourite = () => {
    sendMessage({
      type: "UpdateFavourites",
      payload: [
        ...storedFavourites,
        {
          id: generateFavouriteId(storedFavourites),
          name: generateFavouriteName(MARKETS_VIEW, storedFavourites),
          type: MARKETS_VIEW,
          markets: prefetchedFilters.markets,
        },
      ],
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: MARKETS_VIEW,
      action: CREATE,
    });

    closeFilter();
  };

  const addToSelectedFavourite = () => {
    const existingFavouriteIndex = storedFavourites.findIndex(
      (favourite) => favourite.id === selectedFavourite
    );
    if (existingFavouriteIndex !== -1) {
      const favourites = [...storedFavourites];
      favourites[existingFavouriteIndex] = {
        ...favourites[existingFavouriteIndex],
        markets: [
          ...new Set([
            ...favourites[existingFavouriteIndex].markets,
            ...prefetchedFilters.markets,
          ]),
        ],
      };

      sendMessage({
        type: "UpdateFavourites",
        payload: favourites,
      });

      sendAnalyticsEvent({
        event: FAVOURITES,
        type: MARKETS_VIEW,
        action: ADDTO,
      });
    }

    closeFilter();
  };

  return (
    <div className={`${styles.filterHeader}`}>
      <div className={styles.filterHeaderContainer}>
        <h3 className={styles.filterName}>{children}</h3>
        <button
          type="button"
          aria-label="filter-header-close-button"
          className={styles.filterCloseButton}
          onClick={closeFilter}
        >
          <img src={CloseIcon} alt="Close" />
        </button>
      </div>
      {Boolean(activeView === UPDATE_FAVOURITES_VIEW) && (
        <div className={styles["filterHeaderContainer--buttons"]}>
          <FilterHeaderButton
            name="Create new"
            ariaLabel="filter-header-create-new"
            onClick={createNewFavourite}
          />
          <FilterHeaderButton
            name={"Add to selected"}
            ariaLabel="filter-header-add-to-selected"
            onClick={addToSelectedFavourite}
            disabled={!selectedFavourite}
          />
        </div>
      )}
    </div>
  );
}

export default UpdateFavouritesHeader;
